import React, { useEffect } from 'react'
import { Modal, Row, Col, App, Button, Space} from 'antd'
import { useState } from 'react'
import classes from './loan.module.css'
import { useJiekuanUpdateQuery, useJKchaosongMutation, useJiekuanZTXGMutation } from '../../store/DianShangYeWuApi'
import StateTag from '../../cpn/StateTag';
import LoanNodeCheck from './LoanNodeCheck'
import Asterisk from '../../cpn/Asterisk'
import ReportCheck from '../report/ReportCheck'
import ClientCheck from '../../system/client/ClientCheck'
import DocumentRule from '../../cpn/DocumentRule'
import Icon from '../../cpn/Icon'
import FilePreview from '../../cpn/FilePreview'
import { usePrintModal } from '../../cpn/usePrintModal'
import LoanWithdraw from './LoanWithdraw'
import LoanFinanceAmount from './LoanFinanceAmount'
import AccountCheck from '../../system/account/AccountCheck';
function LoanCheck(props) {
    const yh_qx = props.yh_qx || '';
    const { message } = App.useApp();
    const [openCheck, setOpenCheck] = useState(false)
    const { handlePrint, modalRef } = usePrintModal(openCheck, '借款单')
    const [info, setInfo] = useState({
        jk_content: '',
        jk_ctime: '',
        jk_price: '',
        jk_uname: '',
        jk_num: '',
        jk_type_id: '',
        jk_type_name: '',
        jk_kh_id: '',
        jk_kh_name: '',
        jk_amount: '',
        jk_date: '',
        jk_date_end: '',
        jk_bzd_name: '',
        jk_bzd_danhao: '',
        jk_id: '',
        jk_yuedu: '',
        jk_state: '',
        jk_uid: '',
        jk_bzd_id: '',
        jk_month: '',
        jk_year: '',
        jk_state_time: '',
        jk_cw_content: '',
    })
    const { data, isSuccess } = useJiekuanUpdateQuery({ jk_id: props.jk_id }, { skip: !openCheck, refetchOnMountOrArgChange: 1 })
    useEffect(() => {
        if (isSuccess && data.Status === 'success') {
            setInfo(prev=>({...prev,
                jk_content: data.Result.jk_content,
                jk_ctime: data.Result.jk_ctime,
                jk_price: data.Result.jk_price,
                jk_uname: data.Result.jk_uname,
                jk_num: data.Result.jk_num,
                jk_type_id: data.Result.jk_type_id,
                jk_type_name: data.Result.jk_type_name,
                jk_kh_name: data.Result.jk_kh_name,
                jk_kh_id: data.Result.jk_kh_id,                
                jk_amount: data.Result.jk_amount,
                jk_date: data.Result.jk_date,
                jk_date_end: data.Result.jk_date_end,
                jk_bzd_name: data.Result.jk_bzd_name,
                jk_bzd_danhao: data.Result.jk_bzd_danhao,
                jk_id: data.Result.jk_id,
                jk_yuedu: data.Result.jk_yuedu,
                jk_state: data.Result.jk_state,
                jk_uid: data.Result.jk_uid,
                jk_bzd_id: data.Result.jk_bzd_id,
                jk_month: data.Result.jk_month,
                jk_year: data.Result.jk_year,
                jk_state_time: data.Result.jk_state_time,
                jk_image_file: data.Result.jk_image_file,
                jk_image_name: data.Result.jk_image_name,
                jk_bm_name: data.Result.jk_bm_name,
                jk_bm_id: data.Result.jk_bm_id,
                jk_khyhzh_name: data.Result.jk_khyhzh_name,
                jk_khyhzh_id: data.Result.jk_khyhzh_id,
                jk_cw_content: data.Result.jk_cw_content,
                jk_qyyhzh_name: data.Result.jk_qyyhzh_name,
                jk_qyyhzh_id: data.Result.jk_qyyhzh_id,
                jk_qyyhzh_date: data.Result.jk_qyyhzh_date,
            }))
        }
    }, [data, isSuccess])
    //取消提交
    // const [ztxg] = useJiekuanZTXGMutation()
    // const [isSubmitting, setIsSubmitting] = useState(false)
    const formatCurrency = (value) => {
        if (value === null || value === undefined) return '0.00';
        return `￥${Number(value).toLocaleString('zh-CN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })}`;
    }
    //抄送
    const [jkChaosong] = useJKchaosongMutation()
    //取消提交
    const [ztxg] = useJiekuanZTXGMutation()
    const [isSubmitting, setIsSubmitting] = useState(false)
    return (
        <>
           <a 
                type='check' 
                onClick={() => { 
                    if(props.jk_sp_state==='2' && props.jk_sp_jd_name==='抄送'){
                        jkChaosong({
                            'jk_sp_id': props.jk_sp_id,     //抄送节点id
                            'jk_id': props.jk_id,
                            'jk_sp_yh_id': props.jk_sp_yh_id   //抄送人id
                        }).then((res) => {
                            if(res.data.Status === 'success'){
                                message.success('抄送成功')
                                setOpenCheck(true);  
                            }else{
                                message.error('抄送失败'+res.data.Message)
                            }
                        })
                    }else if(props.jk_state === '5' && props.jk_uid === props.yh_id){
                        ztxg({
                            jk_id:props.jk_id,
                            jk_state: '6',
                        }).then((res) => {
                            if(res.data.Status === 'success'){
                                message.success('已读标记成功')
                                setOpenCheck(true);  
                            }else{
                                message.error('已读标记失败'+res.data.Message)
                            }
                        })
                    }else{
                        setOpenCheck(true);  
                    }
                }} 
            >
                {(props.jk_sp_state==='2' && props.jk_sp_jd_name==='抄送')&&<span style={{color:"red"}}>未读：</span>}
                {(props.jk_state==='5' && props.jk_uid === props.yh_id && props.listType === 'submitted')&&<span style={{color:"red"}}>未读：</span>}
                {props.jk_state==='4'&&<span style={{color:"red"}}>已驳回：</span>}
                {props.jk_sp_jk_kh_name?props.jk_sp_jk_kh_name:props.jk_kh_name}
            </a>
            <Modal
                open={openCheck}
                onCancel={() => setOpenCheck(false)}
                onOk={() => setOpenCheck(false)}
                width={1330}
                footer={[
                    <Button key="print" type="primary" onClick={handlePrint}>
                        打印
                    </Button>,
                    <Button key="close" onClick={() => setOpenCheck(false)}>
                        关闭
                    </Button>
                ]}
            >
                <div ref={modalRef}>
                <Row style={{width:"1280px"}}>
                   {(info.jk_state === '5' || info.jk_state==='6') && <div style={{ position: 'absolute', top: 0, right: 0, zIndex: 10 }}>
                        <img src={'./img/loanFinished.png'} alt="借款单" width={150} height={150}/>
                    </div>} 
                    <Col span={4} className={classes.row_top_left} style={{borderTop:'3px solid #660099',borderLeft:'3px solid #660099'}}></Col>
                    <Col span={16} className={classes.row_top_middle} style={{color:'#660099',borderTop:'3px solid #660099'}}>借款单</Col>
                    <Col span={4} className={classes.row_top_right} style={{borderTop:'3px solid #660099',borderRight:'3px solid #660099'}}></Col>
                    {/* 第一行 */}
                    <Col span={2} className={classes.col_top_label} style={{borderLeft:'3px solid #660099',color:'#660099'}}>团队名称</Col>
                    <Col span={6}  className={classes.col_top_input} style={info.jk_bzd_name ? {} : {padding: '15px'}}>
                        <ReportCheck dsbzd_id={info.jk_bzd_id} dsbzd_name={info.jk_bzd_name} qy_id={props.qy_id} yh_id={props.yh_id} yh_name={props.yh_name} />
                    </Col>  
                    <Col span={2} className={classes.col_top_label} >团队客户类型</Col>
                    <Col span={6}  className={classes.col_top_input}>
                        {info.jk_type_name}
                    </Col>  
                    <Col span={2}  className={classes.col_top_label} >团队客户</Col>
                    <Col span={6}  className={classes.col_right_input}  style={{borderRight:'3px solid #660099'}}>
                        <ClientCheck kh_id={info.jk_price} kh_name={info.jk_num} qy_id={props.qy_id} yh_id={props.yh_id} yh_name={props.yh_name} />
                    </Col> 
                    {/* 第二行 */}
                    <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #660099'}}><Asterisk color='red'/> 日期</Col>
                    <Col span={6}  className={classes.col_middle_input}>
                        {info.jk_date}
                    </Col>
                    <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/>金额</Col>
                    <Col span={6}  className={classes.col_middle_input}>
                        {formatCurrency(info.jk_amount)}
                    </Col>
                    <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 部门</Col>
                    <Col span={6}  className={classes.col_middle_right_input}   style={{borderRight:'3px solid #660099'}}>
                        {info.jk_bm_name}
                    </Col>
                    {/* 第三行 */}
                    <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #660099'}}><Asterisk color='red'/> 借款客户</Col>
                    <Col span={6}  className={classes.col_middle_input}>
                        <ClientCheck kh_id={info.jk_kh_id} kh_name={info.jk_kh_name} qy_id={props.qy_id} yh_id={props.yh_id} yh_name={props.yh_name} />
                    </Col>
                    <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 银行账户</Col>
                    <Col span={14}  className={classes.col_middle_right_input} style={{borderRight:'3px solid #660099'}}>
                        {info.jk_khyhzh_name}
                    </Col>
                    {/* 第四行       */}
                    <Col span={2} className={classes.col_middle_label} style={{borderLeft:'3px solid #660099'}}>备注</Col>
                    <Col span={14}  className={classes.col_middle_input} style={info.jk_content ? {} : {padding: '19px'}}>
                        {info.jk_content}
                    </Col>                                   
                    <Col span={2} className={classes.col_middle_label}>转账记录</Col>
                    <Col span={6}  className={classes.col_middle_input} style={{borderRight:'3px solid #660099'}}>
                        {info.jk_qyyhzh_date} <AccountCheck qyyhzh_id={info.jk_qyyhzh_id} name={info.jk_qyyhzh_name} />
                    </Col>
                    {/* 第五行                             */}  
                    <Col span={2} className={classes.col_middle_label} style={{borderLeft:'3px solid #660099'}}>附件</Col>
                    <Col span={14}  className={classes.col_bottom_input}>
                        <FilePreview 
                            fileNames={info.jk_image_file} 
                            fileUrls={info.jk_image_name} 
                        />
                    </Col>                                   
                    <Col span={2}  className={classes.col_bottom_label}>编号/状态</Col>
                    <Col span={6}  className={classes.col_bottom_right} style={{borderRight:'3px solid #660099'}}>
                        {props.jk_id}&emsp;<StateTag state={info.jk_state} />
                    </Col>   
                    {/* 第六行 */}
                    <Col span={24} className={classes.bottom_row}>
                        <LoanNodeCheck 
                            jk_id={props.jk_id} 
                            qy_id={props.qy_id} 
                            user_id={props.yh_id} 
                            yh_id={props.yh_id}
                            yh_name={props.yh_name} 
                            qy_name={props.qy_name}
                            jk_uname={info.jk_uname}
                            jk_ctime={info.jk_ctime}
                            jk_state_time={info.jk_state_time}
                        />
                    </Col>
                </Row> 
                <Row>
                    <Col span={24} style={{textAlign: 'right',paddingTop: '10px',display:'flex',justifyContent:'space-between'}}>
                        <DocumentRule/>
                        {(props.yh_id === props.jk_uid && props.jk_state ==='4') ? <Icon type='withdraw' onClick={() => {
                                                                                                // 如果正在提交中，直接返回
                                                                                                if (isSubmitting) {
                                                                                                    return;
                                                                                                }
                                                                                                
                                                                                                // 设置提交状态
                                                                                                setIsSubmitting(true);                                                                                                
                                                                                                ztxg({
                                                                                                    jk_id:props.jk_id,
                                                                                                    jk_state: '1',
                                                                                                }).then((res) => {
                                                                                                    if(res.data.Status === 'success') {
                                                                                                        message.success('团队报账单取消提交成功！')
                                                                                                        setOpenCheck(false);
                                                                                                        setIsSubmitting(false);
                                                                                                    }else{
                                                                                                        message.error('团队报账单取消提交失败！'+res.data.Message)
                                                                                                        setOpenCheck(false);
                                                                                                        setIsSubmitting(false);
                                                                                                    }
                                                                                                    // 3秒后恢复可点击状态
                                                                                                    setTimeout(() => {
                                                                                                        setIsSubmitting(false);
                                                                                                    }, 3000);
                                                                                                }).catch((err) => {
                                                                                                    // 出错时也要恢复状态
                                                                                                    setTimeout(() => {
                                                                                                        setIsSubmitting(false);
                                                                                                    }, 3000);
                                                                                                })
                                                                                            }} /> : null}
                        {yh_qx.includes('管理') ?  <Space size={20}>
                            <LoanWithdraw jk_id={props.jk_id} jk_cw_content={info.jk_cw_content} jk_amount={info.jk_amount}/>
                            <LoanFinanceAmount jk_id={props.jk_id} jk_state={info.jk_state} jk_cw_content={info.jk_cw_content} jk_amount={info.jk_amount} />
                        </Space> : null}
                    </Col>
                </Row>
                </div>
            </Modal>
        </>
    )
}

export default LoanCheck